<template>
    <section>
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="filters" ref="queryForm">

                <!--<el-form-item v-if="accountType!=2">
                    <el-select filterable clearable v-model="filters.userId"
                               placeholder="请选择商户">
                        <el-option
                                v-for="item in merchant"
                                :key="item.userId"
                                :label="item.name"
                                :value="item.userId">
                        </el-option>
                    </el-select>
                </el-form-item>-->
                

                <el-form-item>
                    <div class="block">
                        <el-date-picker
                                v-model="date"
                                type="daterange"
                                :picker-options="pickerOptions"
                                placeholder="选择日期时间"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                align="right">
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="query">查询</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <!--列表-->
        <el-table :data="workOrderData" highlight-current-row border stripe v-loading="listLoading"
                  style="width: 100%;text-align: center">
            <el-table-column type="index" width="80">
            </el-table-column>

            <el-table-column prop="workerName" label="员工名称"  min-width="120">
            </el-table-column>
            <el-table-column prop="orderCount" label="订单总量"  min-width="120">
            </el-table-column>
            <el-table-column prop="allOrderMoney" label="订单总费用" :formatter="formatMoney" min-width="120">
            </el-table-column>
            <el-table-column prop="allPlatformMoney" label="订单总差价" :formatter="formatMoney" min-width="120">
            </el-table-column>

        </el-table>

    </section>
</template>

<script>
    import util from '../../common/js/util'
    import NProgress from 'nprogress'
    import {requestPost} from '../../api/api';
    import {data} from "../../common/data";

    export default {
        data() {
            return {
                filters: {
                    startTime: '',
                    endTime: '',
                },
                pickerOptions: data.pickerOPtions,
                accountType:sessionStorage.getItem('type'),
                workOrderData: [],
                merchant: [],
                type: data.type,
                rowCount: 20,
                page: 1,
                listLoading: false,
                date: [new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0), new Date()]


            }

        },
        mounted: function () {


        },

        methods: {


            formatMoney: function (row, column) {
                if (row.allOrderMoney&&column.label=='订单总费用')
                    return row.allOrderMoney / 100;
                else if(row.allPlatformMoney&&column.label=='订单总差价')
                    return row.allPlatformMoney / 100;
            },


            query() {
                this.listLoading = true;
                var url = "sta/workerOrderSta.do?t=" + new Date().getTime();
                let para = Object.assign({}, this.filters);
                para.startTime = util.formatDate.format(new Date(this.date.toString().split(',')[0]), 'yyyy-MM-dd')+" 00:00:00";
                para.endTime = util.formatDate.format(new Date(this.date.toString().split(',')[1]), 'yyyy-MM-dd')+" 23:59:59";;

                requestPost(this, url, para).then((res) => {
                    if (res != '') {

                        this.workOrderData = res.data;
                    }
                    this.listLoading = false;

                });
            }
        }
    }

</script>

<style scoped>
    .el-table th {
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// workerOrderSta.vue?605d6f43